import { render, staticRenderFns } from "./attachment-preview.vue?vue&type=template&id=2579b3b4&scoped=true&"
import script from "./attachment-preview.vue?vue&type=script&lang=js&"
export * from "./attachment-preview.vue?vue&type=script&lang=js&"
import style0 from "./attachment-preview.vue?vue&type=style&index=0&id=2579b3b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2579b3b4",
  null
  
)

export default component.exports